<template>
  <div class="_component-post-detail">
    <Form v-if="isNew" />
    <Pay v-else :id="id" />
  </div>
</template>
<script>
export default {
  name: 'Detail',
  components: {
    Form: () => import('./Form'),
    Pay: () => import('./Pay')
  },
  computed: {
    isNew() {
      return !this.id;
    },
    id() {
      return this.$route.params.id;
    }
  }
};
</script>
